import React from "react";
import "./Text.css";

const STYLES = ["txt--default", "txt--bold", "txt--italic"];

const SIZES = ["txt--small", "txt--medium", "txt--big"];

const Text = ({ children, content, type, textStyle, textSize }) => {
  const checkTextStyle = STYLES.includes(textStyle) ? textStyle : STYLES[0];

  const checkTextSize = SIZES.includes(textSize) ? textSize : SIZES[0];
  return (
    <p className={`txt ${checkTextStyle} ${checkTextSize}  `} type={type}>
      {children}
      {content}
    </p>
  );
};

export default Text;
